(function documentControllerDefinition() {
    'use strict';

    angular.module('Migrator')
        .controller('MigratorBatchDetailController', [
            '$scope', '$translate', '$state', 'errorsExtend', '$stateParams', 'migratorService', 'storageService','authExtend',
        function migratorDetailController($scope, $translate, $state, errors, $stateParams, migratorService, storageService, authExtend) {

            $scope.cancel = function () {
                $state.goBack();
            };
            $scope.btnViewDocument = authExtend.isInRole('DOCUMENT READ') || authExtend.isInRole('DOCUMENT WRITE') || authExtend.isInRole('DOCUMENTVERSIONED WRITE');

            $scope.load = function () {
                $scope.migrator =
                    {
                        documents: [],
                        batch: $stateParams.nro
                    };

                migratorService.getBatch($stateParams.id, $stateParams.nro).then(function (result) {
                    $scope.migrator.documents = result;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                });
            };

            $scope.view = function (id) {
                $state.go('document-detail', { id: id });
            };

            $scope.load();
        }
        ]);
})();